import React from 'react';
import PartNumber from 'shared/components/parameters/PartNumber';
import Revision from 'shared/components/parameters/Revision';
import StencilFile from 'shared/components/parameters/StencilFile';
import LengthText from 'shared/components/carriers/LengthText';
import WidthText from 'shared/components/carriers/WidthText';
import PrintConfirmation from 'shared/components/PrintConfirmationRadio';
import SpecialInstruction from 'shared/components/SpecialInstruction';
import ProductQuoteNumber from 'shared/components/ProductQuoteNumber';
import RowSelected from 'shared/components/RowSelected';
import ColumnSelected from 'shared/components/ColumnSelected';
import MaterialThickness from 'shared/components/carriers/MaterialThickness';
import RequiredInformation from 'shared/components/RequiredInformation';
import Hardware from 'selective_solder_fixtures/components/Hardware';

const Parameters = (props) => {
  const { parameters, validator } = props;

  validator.purgeFields();

  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-6">
          <PartNumber {...props}>
            <span className="error">
              {validator.message(`Part Number`, parameters.part_number, 'required|min:3')}
            </span>
          </PartNumber>
        </div>
        <div className="col-12 col-lg-6">
          <Revision {...props} label="Revision number">
            <span className="error">
              {validator.message(`Revision`, parameters.revision, 'required')}
            </span>
          </Revision>
        </div>
        <div className="col-12 col-lg-6">
          <MaterialThickness {...props} />
        </div>
        <div className="col-12 col-lg-6">
          <StencilFile required {...props}>
            <span className="error">
              {validator.message(`Zip File`, parameters.filename, 'required')}
            </span>
          </StencilFile>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-lg-6">
              <WidthText {...props}>
                <span className="error">
                  {validator.message(`Carrier Width`, parameters.carrier_width, 'required|numeric|min:0.1,num|max:20,num')}
                </span>
              </WidthText>
            </div>
            <div className="col-lg-6">
              <LengthText {...props}>
                <span className="error">
                  {validator.message(`Carrier Length`, parameters.carrier_length, 'required|numeric|min:0.1,num|max:24,num')}
                </span>
              </LengthText>
            </div>
          </div>
        </div>
        <div className="col-12">
          <PrintConfirmation {...props}>
            <span className="error">
              {validator.message(`Check plot confirmation`, parameters.print_confirmation, 'required')}
            </span>
          </PrintConfirmation>
        </div>
        <div className="col-12">
          <Hardware {...props} validator={validator} />
        </div>

        <div className="col-12">
          <SpecialInstruction {...props} />
          <ProductQuoteNumber {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <RequiredInformation />
        </div>
      </div>
    </div>
  );
};

export default Parameters;
